import { createContext } from 'react';

const CurrentUserContext = createContext({
  moo: 'cow',
});

export default CurrentUserContext;



// WEBPACK FOOTER //
// ./src/contexts/CurrentUser.js